export function PageSkeleton() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Header skeleton */}
      <div className="h-16 border-b border-border bg-white" />
      {/* Content skeleton */}
      <div className="mx-auto w-full max-w-7xl flex-1 px-4 py-8 sm:px-6 lg:px-8">
        <div className="animate-pulse space-y-6">
          <div className="h-8 w-48 rounded-[var(--radius-sm)] bg-bg-tertiary" />
          <div className="h-4 w-96 rounded-[var(--radius-sm)] bg-bg-tertiary" />
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="space-y-3">
                <div className="aspect-[4/5] rounded-[var(--radius-md)] bg-bg-tertiary" />
                <div className="h-4 w-3/4 rounded bg-bg-tertiary" />
                <div className="h-4 w-1/2 rounded bg-bg-tertiary" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
